import React from "react";
import Button from "Components/button/Button";

import WarningBanner from "Components/warningBanner/WarningBanner";
import Toggle from "Components/toggle/Toggle";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { Icon, close } from "Icons/index";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import AddDeliveryAccountModal from "./AddDeliveryAccountModal";

import s from "./permissionTeamMembers.scss";

export default class Permissions extends React.Component {
  constructor(props) {
    super(props);

    let translations = {};

    this.props.permissions.forEach((p) => {
      translations[p.name] = p.label;
    });

    let sections = [
      {
        title: "settings.sections.domains.title",
        description: "settings.sections.domains.desc",
        perms: ["see_domains", "create_domains", "disable_domains", "delete_domains"],
      },
      {
        title: "settings.sections.accounts.title",
        description: "settings.sections.accounts.desc",
        perms: [
          "create_email_accounts",
          "disable_email_accounts",
          "edit_email_accounts",
          "delete_email_accounts",
          "change_email_accounts_pwd",
        ],
      },
      {
        title: "settings.sections.archive.title",
        description: "settings.sections.archive.desc",
        perms: [
          "see_vault_email_accounts",
          "create_vault_email_accounts",
          "disable_vault_email_accounts",
          "delete_vault_email_accounts",
          "manage_vault_delegate",
          // "disable_vault_delegate"
        ],
      },

      {
        title: "settings.sections.analysis.title",
        description: "settings.sections.analysis.desc",
        perms: ["see_etlive", "see_audits", "see_support"],
      },

      {
        title: "settings.sections.api.title",
        description: "settings.sections.api.desc.teamMember",
        perms: ["use_api"],
      },
    ];

    if (props.teamMember.is_customer_reseller || props.teamMember.is_customer_wholesale) {
      sections[0].perms.push("manage_managers");
    }

    let deliveryAccountsCachedInfo = {};

    this.state = {
      viewFields: [...this.props.permissions.map((perm) => perm.name)],
      translations: translations,
      isAddDeliveryAccountModalOpen: false,
      sections,
      deliveryAccountsCachedInfo,
      domainRelatedPermissions: [
        "create_domains",
        "disable_domains",
        "edit_email_accounts",
        "create_email_accounts",
        "disable_email_accounts",
        "see_vault_email_accounts",
        "create_vault_email_accounts",
        "disable_vault_email_accounts",
        "delete_vault_email_accounts",
        "manage_vault_delegate",
        // "disable_vault_delegate",
        "delete_domains",
        "delete_email_accounts",
        "change_email_accounts_pwd",
        "manage_managers",
      ],
      archiveRelatedPermissions: [
        "create_vault_email_accounts",
        "disable_vault_email_accounts",
        "delete_vault_email_accounts",
        "manage_vault_delegate",
        // "disable_vault_delegate"
      ],
      influenceBilling: {
        create_vault_email_accounts: true,
        create_email_accounts: true,
        edit_email_accounts: true,
      },
    };
  }

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.permissions.length > 0) {
      this.setState({ viewFields: nextProps.permissions.map((perm) => perm.name) });
    }

    // set translations if coming in later
    if (
      Object.keys(this.state.translations).length === 0 &&
      nextProps.permissions &&
      nextProps.permissions.length > 0
    ) {
      let translations = {};

      nextProps.permissions.forEach((p) => {
        translations[p.name] = p.label;
      });

      this.setState({ translations });
    }
  }

  submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.submitForm(this.props.formData, this.state.viewFields, true);
  };

  setValue = (data) => {
    if (Object.keys(data)[0] === "see_domains" && data.see_domains === false) {
      this.state.domainRelatedPermissions.forEach((perm) => {
        this.props.setFormFieldValue({ [perm]: false });
      });
    }

    if (Object.keys(data)[0] === "see_vault_email_accounts" && data.see_vault_email_accounts === false) {
      this.state.archiveRelatedPermissions.forEach((perm) => {
        this.props.setFormFieldValue({ [perm]: false });
      });
    }

    this.props.setFormFieldValue(data);
  };

  isDisabled = (perm) => {
    if (this.state.domainRelatedPermissions.includes(perm) && !this.props.formData.see_domains) {
      return true;
    } else if (this.state.archiveRelatedPermissions.includes(perm) && !this.props.formData.see_vault_email_accounts) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { formErrors, formData, isFormLoading } = this.props;

    return (
      <>
        <form className={s.general} method="post" onSubmit={this.submit}>
          <div className={s.wrapInfoBtn}>
            <div className={s.warnignMsg}>
              {!this.props.areFieldsPristine(...this.state.viewFields) && !formErrors.onForm && (
                <WarningBanner color="yellow-text" msg={t("infoMsg.unsaveChanged")} />
              )}

              {formErrors.onForm && (
                <div className="warningMsgFP">
                  <WarningBanner color="red" msg={formErrors.onForm} />
                </div>
              )}
            </div>
            <div className={s.infoBtnGroup}>
              <Button docsKey="teamMembers_settings" color="docs" type="button">
                button.docs
              </Button>
              <Button type="submit" loading={isFormLoading}>
                button.save
              </Button>
            </div>
          </div>

          <div className={s.settings}>
            {this.state.sections.map((sec, i) => (
              <div className="sectionSP" key={i}>
                <div className="infoSectionSP">
                  <div className="settingTitle">{t(sec.title)}</div>
                  <div className="sectionDesc">{t(sec.description)}</div>
                </div>
                <div className="formsSectionSP">
                  {sec.perms.map((per) => {
                    return (
                      <Toggle
                        label={this.state.translations[per]}
                        key={per}
                        name={per}
                        className="inputFull2"
                        disabled={this.isDisabled(per)}
                        checked={formData[per] && !formData.see_domains ? !this.isDisabled(per) : formData[per]}
                        onChange={this.setValue}
                        hint={this.state.influenceBilling[per] ? t("infoMsg.canInfluenceBilling") : null}
                      />
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </form>
      </>
    );
  }
}
